__turbopack_context__.v({
  "tab": "Tabs-module__jUs5MG__tab",
  "tabMinimal": "Tabs-module__jUs5MG__tabMinimal",
  "tabPanel": "Tabs-module__jUs5MG__tabPanel",
  "tabsContainer": "Tabs-module__jUs5MG__tabsContainer",
  "tabsList": "Tabs-module__jUs5MG__tabsList",
  "tabsListMinimal": "Tabs-module__jUs5MG__tabsListMinimal",
});
